/**
 * watchlist-item-updated-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tsmith@safetyweb.org>
 */

import { TypedDataHolder } from "../../../common/data/typed-data";
import { SubjectContextType, KnownSubjectContextTypes }
    from "../../../subjects/subject-context-type";
import { Displayable } from "../../../support/types/aliases";
import { WatchlistEntry } from "../../../watchlist/watchlist-entry";
import { validateAs, validateFor, validateOpaqueID }
    from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

/**
 * The {@link WatchlistItemUpdatedResponse} notifies the client of successful
 * changes to watchlist entries.
 */
@validateFor(MessageTag.RSP_WATCHLIST_ITEM_UPDATED)
export class WatchlistItemUpdatedResponse extends IncomingMessage
    implements WatchlistEntry
{
    /** The unique tag for this message type */
    public tag : MessageTag = MessageTag.RSP_WATCHLIST_ITEM_UPDATED;

    @validateAs("string")
    public note : string;

    @validateAs({array: "object"}) // TODO: better validation
    public summary : Array<TypedDataHolder & Displayable>;

    @validateAs("boolean")
    public alert : boolean;

    @validateAs("integer")
    public lastObserved : number;

    @validateAs("integer", true)
    public groupId? : number;

    @validateAs({enum: Object.values(KnownSubjectContextTypes)})
    public contextType : SubjectContextType;

    @validateAs("boolean")
    public emailNotifyOnUpdate : boolean;

    @validateOpaqueID()
    public objectId : number;

    @validateOpaqueID()
    public watchId : number;

    public categories : string[];
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/watchlists/watchlist-item-updated-response.ts